/** Recon scope options (must match services/recon/reconScope.js). */
export const RECON_SCOPE_OPTIONS = [
  {
    id: 'payroll',
    label: 'Payroll wage types',
    hint: 'Payroll wage types from the full wage-type mapping pack.',
  },
  {
    id: 'benefits',
    label: 'Benefit recon',
    hint: 'Medical, dental, HSA, FSA, and other benefit wage types only.',
  },
  {
    id: 'time',
    label: 'Time recon',
    hint: 'G2 hours vs hours paid on the register — requires a G2 time file.',
  },
];

export const DEFAULT_RECON_SCOPE = 'payroll';

export function scopeUsesDollars(scopeId) {
  return scopeId === 'payroll' || scopeId === 'benefits';
}

export function scopeUsesHours(scopeId) {
  return scopeId === 'time';
}
